import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PersonPage } from "@/features/people360/person-page";

/** The person page (Customer 360): every interaction of one person. `?show=comments|dms` pre-filters the timeline. */
export const Route = createFileRoute("/_app/people/$contactId")({
  validateSearch: z.object({ show: z.enum(["all", "comments", "dms", "automation", "team"]).optional().catch(undefined) }),
  head: () => ({ meta: [{ title: "Person · Malfak" }] }),
  component: PersonRoute,
});

function PersonRoute() {
  const { contactId } = Route.useParams();
  const { show } = Route.useSearch();
  return <PersonPage key={contactId} contactId={contactId} show={show} />;
}
